import { Box, Stack, Typography } from '@mui/material'
import grey from '@mui/material/colors/grey'
import { UserCurrentIcon } from 'app/imports/App.components'
import React from 'react'
import { formatDate } from 'utils'

export const TimelineItemHeader = ({
  title,
  showAvatar,
  hideBorderBottom = false,
  authorName,
  date,
  bannerUrl,
  onClick,
}: {
  title: string
  showAvatar: boolean
  hideBorderBottom?: boolean
  authorName?: string
  date?: string
  bannerUrl?: string | null
  onClick?: () => void
}) => {
  return (
    <Stack
      direction="row"
      spacing={{ sm: 2, xs: 1.5 }}
      sx={{
        borderBottom: hideBorderBottom ? '' : '1px solid',
        borderColor: grey[300],
        cursor: onClick ? ' pointer' : '',
      }}
      paddingBottom={1}
      alignItems="center"
      onClick={onClick}
    >
      {showAvatar && (
        <Box
          display="flex"
          flexShrink={0}
          alignSelf="flex-start"
          sx={{ maxWidth: '60px', minWidth: '60px' }}
        >
          {bannerUrl ? <img src={bannerUrl} /> : <UserCurrentIcon />}
        </Box>
      )}
      <Stack>
        <Typography variant="h5">{title}</Typography>
        <Stack direction="row" flexWrap="wrap">
          {authorName && (
            <Typography color="textSecondary" marginRight={1}>
              by {authorName}
            </Typography>
          )}
          {date && (
            <Typography color="textSecondary">{formatDate(date, 'MMM. Do, YYYY')}</Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}
